enum QuestionTypes {
  SingleChoice = 'singleChoice',
  MultiChoice = 'multiChoice',
  ShortText = 'shortText',
  ConnectionGrid = 'connectionGrid',
  Ranking = 'ranking',
  TopList = 'topList',
  ImagePin = 'imagePin'
};

export default QuestionTypes;
